import React from 'react';
import { FileText, Trash2, Edit } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const TemplateCard = ({ template, onLoad, onDelete }) => {
  const { t, i18n } = useTranslation();
  console.log('🎴 TemplateCard render:', template);

  const mediaCount = template.media?.length || 0;
  const hasContent = template.content && template.content.length > 0;

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      // Get the current language from i18n
      const locale = i18n.language === 'tr' ? 'tr-TR' :
                     i18n.language === 'de' ? 'de-DE' :
                     i18n.language === 'es' ? 'es-ES' :
                     i18n.language === 'fr' ? 'fr-FR' : 'en-US';
      return date.toLocaleDateString(locale, {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    } catch (e) {
      return t('dashboard.templates.noDate');
    }
  };

  return (
    <div className="border-2 border-gray-200 rounded-lg p-3 hover:border-blue-400 hover:shadow-md transition-all bg-white">
      <div className="flex items-start justify-between gap-3">
        {/* Sol Taraf - İkon ve Bilgiler */}
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <div className="w-10 h-10 bg-gradient-to-br from-blue-100 to-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
            <FileText className="w-5 h-5 text-blue-600" />
          </div>

          <div className="flex-1 min-w-0">
            {/* Başlık */}
            <h4 className="font-bold text-gray-800 text-sm truncate" title={template.name}>
              {template.name}
            </h4>

            {/* İçerik Önizleme */}
            {hasContent && (
              <p className="text-xs text-gray-600 truncate mt-1">
                {template.content}
              </p>
            )}

            {/* Meta */}
            <div className="flex items-center gap-2 mt-1 text-xs text-gray-500">
              <span>{t('common.characterCount', { count: template.content?.length || 0 })}</span>
              {mediaCount > 0 && (
                <>
                  <span>•</span>
                  <span>{t('dashboard.templates.mediaCount', { count: mediaCount })}</span>
                </>
              )}
            </div>

            {/* Tarih */}
            <p className="text-xs text-gray-400 mt-1">
              {formatDate(template.createdAt)}
            </p>
          </div>
        </div>

        {/* Sağ Taraf - Butonlar */}
        <div className="flex flex-col gap-1 flex-shrink-0">
          <button
            onClick={() => {
              console.log('✅ Kullan butonuna tıklandı, template:', template);
              onLoad(template);
            }}
            className="flex items-center justify-center gap-1 bg-blue-600 text-white px-2 py-1.5 rounded hover:bg-blue-700 transition text-xs font-semibold"
            title={t('dashboard.templates.useTemplate')}
          >
            <Edit className="w-3 h-3" />
            {t('dashboard.templates.use')}
          </button>
          <button
            onClick={() => {
              console.log('🗑️ Sil butonuna tıklandı, template ID:', template.id);
              onDelete(template.id);
            }}
            className="flex items-center justify-center gap-1 bg-red-100 text-red-600 px-2 py-1.5 rounded hover:bg-red-200 transition text-xs font-semibold"
            title={t('dashboard.templates.deleteTemplate')}
          >
            <Trash2 className="w-3 h-3" />
            {t('common.delete')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TemplateCard;
